import { Button } from './ui/button';
import { Compass, Users, Home, BookOpen, Trees, Calendar } from 'lucide-react';
import { JoinMovementModal } from './JoinMovementModal';
export const LeaderSection = () => {
  return <section id="leader" className="py-24 bg-card relative">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="mb-8">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-6 text-foreground leading-tight"> Join the Club</h2>
          <div className="w-32 h-px bg-gradient-to-r from-transparent via-accent to-transparent mx-auto mb-8"></div>
        </div>
        
        <div className="max-w-3xl mx-auto mb-10">
          <p className="text-xl text-muted-foreground font-light leading-relaxed mb-12">
            A growing circle for those who seek balance, connection, and a slower pace of life.
          </p>
          
          <div className="mb-12">
            <p className="text-lg text-foreground font-medium mb-8">
              We bring together:
            </p>
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12 items-stretch">
              <div className="relative bg-card/80 backdrop-blur-sm p-10 rounded-3xl border border-accent/30 shadow-2xl overflow-hidden transition-all duration-300 group h-full flex flex-col">
                <div className="w-14 h-14 bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-5 group-hover:scale-110 group-hover:bg-accent/30 transition-all duration-300">
                  <Compass className="w-7 h-7 text-accent" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3 text-center">Explorers</h3>
                <div className="w-16 h-px bg-gradient-to-r from-transparent via-accent to-transparent mx-auto mb-4"></div>
                <p className="text-foreground leading-relaxed text-center mb-2 font-medium">For those seeking balance and relief.</p>
                <p className="text-muted-foreground leading-relaxed text-center text-sm">Join our retreats and workshops to slow down, reconnect, and restore your inner rhythm — offline, in nature, and among like-minded souls.</p>
              </div>
              <div className="relative bg-card/80 backdrop-blur-sm p-10 rounded-3xl border border-accent/30 shadow-2xl overflow-hidden transition-all duration-300 group h-full flex flex-col">
                <div className="w-14 h-14 bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-5 group-hover:scale-110 group-hover:bg-accent/30 transition-all duration-300">
                  <Users className="w-7 h-7 text-accent" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3 text-center">Creators</h3>
                <div className="w-16 h-px bg-gradient-to-r from-transparent via-accent to-transparent mx-auto mb-4"></div>
                <p className="text-foreground leading-relaxed text-center mb-2 font-medium">For those who hold space for others.</p>
                <p className="text-muted-foreground leading-relaxed text-center text-sm">If you guide, teach, or facilitate mindful experiences, Mystic Forest is a space to share your craft and co-create meaningful moments together.</p>
              </div>
              <div className="relative bg-card/80 backdrop-blur-sm p-10 rounded-3xl border border-accent/30 shadow-2xl overflow-hidden transition-all duration-300 group h-full flex flex-col">
                <div className="w-14 h-14 bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-5 group-hover:scale-110 group-hover:bg-accent/30 transition-all duration-300">
                  <Home className="w-7 h-7 text-accent" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3 text-center">Hosts & Venues</h3>
                <div className="w-16 h-px bg-gradient-to-r from-transparent via-accent to-transparent mx-auto mb-4"></div>
                <p className="text-foreground leading-relaxed text-center mb-2 font-medium">For those who open doors to connection.</p>
                <p className="text-muted-foreground leading-relaxed text-center text-sm">Collaborate with us to host gatherings that blend simplicity, nature, and authenticity — creating spaces where presence truly flourishes.</p>
              </div>
            </div>
          </div>
          
          <div className="relative bg-card/80 backdrop-blur-sm p-12 md:p-16 rounded-3xl border border-accent/30 mb-10 shadow-2xl overflow-hidden">
            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-accent/5 via-transparent to-accent/10 opacity-50"></div>
            
            <div className="relative z-10 max-w-2xl mx-auto text-center">
              {/* Main headline */}
              <div className="mb-8">
                <h3 className="text-3xl md:text-4xl font-serif font-light text-foreground mb-4 leading-tight">Join the Club</h3>
                <div className="w-20 h-px bg-gradient-to-r from-transparent via-accent to-transparent mx-auto mb-6"></div>
                <p className="text-lg leading-relaxed">
                  <span className="relative inline-block">
                    <span className="absolute inset-0 bg-lime-400 opacity-60 transform -rotate-1 rounded-sm -z-10"></span>
                    <span className="relative px-2 py-1 text-black">The slowest Club you'll ever want to join.</span>
                  </span>
                </p>
              </div>
              
              {/* Benefits - Bullet style with Mystic Forest icons */}
              <div className="mb-10 max-w-2xl mx-auto space-y-4">
                <div className="flex items-center justify-center gap-4 group">
                  <div className="flex-shrink-0">
                    <Calendar className="w-5 h-5 text-accent" />
                  </div>
                  <p className="text-foreground font-serif text-lg leading-relaxed text-center">
                    Early access to new retreats and workshops
                  </p>
                </div>
                
                <div className="flex items-center justify-center gap-4 group">
                  <div className="flex-shrink-0">
                    <Trees className="w-5 h-5 text-accent" />
                  </div>
                  <p className="text-foreground font-serif text-lg leading-relaxed text-center">
                    Updates on Mystic Forest's journey
                  </p>
                </div>
                
                <div className="flex items-center justify-center gap-4 group">
                  <div className="flex-shrink-0">
                    <BookOpen className="w-5 h-5 text-accent" />
                  </div>
                  <p className="text-foreground font-serif text-lg leading-relaxed text-center">
                    Inspiration from our latest stories and blog posts
                  </p>
                </div>
              </div>
              
              {/* CTA */}
              <div className="space-y-4">
                <JoinMovementModal trigger={<Button className="px-16 py-7 text-lg font-medium bg-accent hover:bg-accent/90 text-accent-foreground shadow-lg hover:shadow-2xl transition-all duration-300 rounded-full group relative overflow-hidden">
                    <span className="relative z-10 flex items-center gap-2">
                      <BookOpen className="w-5 h-5" />
                      Join the Club
                    </span>
                    {/* Animated shine effect */}
                    <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
                  </Button>} />
                <p className="text-sm text-muted-foreground">
                  No spam, just authentic connection
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};